import React from "react"
import TableHeaderRow from "../../ui/TableHeaderRow"
import TableHeader from "../../ui/TableHeader"
import Table, { Cell, Row } from "../../ui/Table"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { selectAdvancedMode } from "../settings/slice"
import Timestamp from "../../ui/Timestamp"
import SortHeader from "../sorting/SortHeader"
import DateTimeFilter from "../filters/DateTimeFilter"
import TextFilter from "../filters/TextFilter"
import separateStrings from "../../strings/stringSplitter"

/**
 * Renders a list of user access logs matching the filters
 *
 * @param accounts
 * @param filter
 * @param setFilter
 * @param stickyHeader
 * @returns {JSX.Element}
 * @constructor
 */
const AccessLogsTable = ({
  accessLogs = [],
  filter = {},
  setFilter = () => {},
  stickyHeader = true,
}) => {
  const advancedMode = useSelector(selectAdvancedMode)

  return (
    <Table>
      <TableHeaderRow sticky={stickyHeader}>
        <TableHeader
          filterControl={
            <TextFilter
              filterByName="user_ids"
              filter={filter}
              setFilter={setFilter}
              active={filter?.user_ids?.length > 0 ? true : false}
              transform={(v) =>
                Array.from(
                  new Set(separateStrings(v, ",;: ").filter((id) => id != ""))
                ).join(",")
              }
            />
          }
          sortControl={
            <SortHeader
              setFilter={setFilter}
              filter={filter}
              sortBy={"user_id"}
            />
          }
        >
          User
        </TableHeader>
        <TableHeader
          sortControl={
            <SortHeader
              setFilter={setFilter}
              filter={filter}
              sortBy={"ip_addr"}
            />
          }
        >
          IP
        </TableHeader>
        <TableHeader
          filterControl={
            <DateTimeFilter
              filter={filter}
              setFilter={setFilter}
              active={filter.from || filter.to ? true : false}
            />
          }
          sortControl={
            <SortHeader setFilter={setFilter} filter={filter} sortBy={"at"} />
          }
        >
          At
        </TableHeader>
      </TableHeaderRow>
      {accessLogs && (
        <tbody>
          {accessLogs.map((accessLog) => (
            <Row key={accessLog.id} zebra>
              <Cell>
                <div>{accessLog.user_id}</div>
              </Cell>
              <Cell>{accessLog.ip_addr}</Cell>
              <Cell>
                <Timestamp utc={advancedMode} columnMode={true}>
                  {accessLog.at}
                </Timestamp>
              </Cell>
            </Row>
          ))}
        </tbody>
      )}
    </Table>
  )
}

AccessLogsTable.propTypes = {
  accessLogs: PropTypes.array, // the access logs to render
  filter: PropTypes.object, // If provided will be used to power the filters if not filters will not be shown
  setFilter: PropTypes.func, // If provided will be used to power the filters if not filters will not be shown
  stickyHeader: PropTypes.bool, // If true, table header is sticky
  hideFilters: PropTypes.bool, // If provided hides the filters for the table
}

export default AccessLogsTable
